import { BrowserRouter, Routes, Route } from "react-router-dom";
import Splash from "./components/Splash";
import ScrollManager from "./components/ScrollManager";
import ErrorBoundary from "./components/ErrorBoundary";
import HomePage from "./pages/HomePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import HomeVisionPage from "./pages/HomeVisionPage";
import MaterialsPage from "./pages/MaterialsPage";
import ProfessionalsPage from "./pages/ProfessionalsPage";
import PricingPage from "./pages/PricingPage";
import ProductPage from "./pages/ProductPage";
import AboutPage from "./pages/AboutPage";
import SectorsPage from "./pages/SectorsPage";
import PilotPage from "./pages/PilotPage";
import SampleReportPage from "./pages/SampleReportPage";
import TrustPage from "./pages/TrustPage";
import FaqsPage from "./pages/FaqsPage";
import InsightsPage from "./pages/InsightsPage";
import ArticlePage from "./pages/ArticlePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ComingNext from "./pages/ComingNext";

function App() {
    return (
        <ErrorBoundary>
            <Splash />
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                        path="/how-it-works"
                        element={<HowItWorksPage />}
                    />
                    <Route
                        path="/home-vision"
                        element={<HomeVisionPage />}
                    />
                    <Route
                        path="/materials-intelligence"
                        element={<MaterialsPage />}
                    />
                    <Route
                        path="/for-professionals"
                        element={<ProfessionalsPage />}
                    />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/product" element={<ProductPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/sectors" element={<SectorsPage />} />
                    <Route path="/sample-report" element={<SampleReportPage />} />
                    <Route path="/trust" element={<TrustPage />} />
                    <Route path="/faqs" element={<FaqsPage />} />
                    <Route path="/insights" element={<InsightsPage />} />
                    <Route path="/insights/:slug" element={<ArticlePage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route
                        path="/join-the-pilot"
                        element={<PilotPage />}
                    />
                    <Route path="*" element={<ComingNext />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
